"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcrolusDocumentType = exports.OcrolusEarningsType = void 0;
/** @TranslateToPython */
var OcrolusEarningsType;
(function (OcrolusEarningsType) {
    OcrolusEarningsType["ALLOWANCE"] = "ALLOWANCE";
    OcrolusEarningsType["BEREAVEMENT"] = "BEREAVEMENT";
    OcrolusEarningsType["BONUS"] = "BONUS";
    OcrolusEarningsType["COMMISSION"] = "COMMISSION";
    OcrolusEarningsType["HOLIDAY_PAY"] = "HOLIDAY PAY";
    OcrolusEarningsType["JURY_DUTY"] = "JURY DUTY";
    OcrolusEarningsType["LEAVE"] = "LEAVE";
    OcrolusEarningsType["LONG_TERM_DISABILITY_PAYMENT"] = "LONG TERM DISABILITY PAYMENT";
    OcrolusEarningsType["MILITARY_PAY"] = "MILITARY PAY";
    OcrolusEarningsType["OTHER"] = "OTHER";
    OcrolusEarningsType["OVERTIME"] = "OVERTIME";
    OcrolusEarningsType["PAID_TIME_OFF"] = "PAID TIME OFF";
    OcrolusEarningsType["PER_DIEM"] = "PER DIEM";
    OcrolusEarningsType["REFERRAL_BONUS"] = "REFERRAL BONUS";
    OcrolusEarningsType["REGULAR_PAY"] = "REGULAR PAY";
    OcrolusEarningsType["REIMBURSEMENTS"] = "REIMBURSEMENTS";
    OcrolusEarningsType["RETENTION_BONUS"] = "RETENTION BONUS";
    OcrolusEarningsType["RETROACTIVE_BACK_PAY"] = "RETROACTIVE/BACK PAY";
    OcrolusEarningsType["SEVERANCE_PAY"] = "SEVERANCE PAY";
    OcrolusEarningsType["SHIFT_DIFFERENTIAL"] = "SHIFT DIFFERENTIAL";
    OcrolusEarningsType["SHORT_TERM_DISABILITY_PAYMENT"] = "SHORT TERM DISABILITY PAYMENT";
    OcrolusEarningsType["SICK_DAY"] = "SICK PAY";
    OcrolusEarningsType["SIGNING_BONUS"] = "SIGNING BONUS";
    OcrolusEarningsType["TIPS_INCOME"] = "TIPS INCOME";
    OcrolusEarningsType["VACATION"] = "VACATION";
    OcrolusEarningsType["MEDICAL"] = "MEDICAL";
    OcrolusEarningsType["RSU"] = "RSU";
    OcrolusEarningsType["LIFE_INSURANCE"] = "LIFE INSURANCE";
    OcrolusEarningsType["DENTAL"] = "DENTAL";
    OcrolusEarningsType["INVESTMENTS"] = "INVESTMENTS";
    OcrolusEarningsType["HEALTH_SAVINGS"] = "HEALTH SAVINGS ACCOUNT/HSA/FSA";
})(OcrolusEarningsType || (exports.OcrolusEarningsType = OcrolusEarningsType = {}));
/** @TranslateToPython */
var OcrolusDocumentType;
(function (OcrolusDocumentType) {
    OcrolusDocumentType["PAYSTUB"] = "PAYSTUB";
    OcrolusDocumentType["W2"] = "W2";
    OcrolusDocumentType["A_1040_2025"] = "A_1040_2025";
    OcrolusDocumentType["A_1040_2024"] = "A_1040_2024";
    OcrolusDocumentType["A_1040_2023"] = "A_1040_2023";
    OcrolusDocumentType["A_1040_2022"] = "A_1040_2022";
    OcrolusDocumentType["A_1040_SR_2025"] = "A_1040_SR_2025";
    OcrolusDocumentType["A_1040_SR_2024"] = "A_1040_SR_2024";
    OcrolusDocumentType["A_1040_SR_2023"] = "A_1040_SR_2023";
    OcrolusDocumentType["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    OcrolusDocumentType["STATE_TAX_RETURN"] = "STATE_TAX_RETURN";
    // Below are unsupported types
    // 1099
    OcrolusDocumentType["A_1099_G"] = "A_1099_G";
    OcrolusDocumentType["A_1099_INT"] = "A_1099_INT";
    OcrolusDocumentType["A_1099_K"] = "A_1099_K";
    OcrolusDocumentType["A_1099_MISC"] = "A_1099_MISC";
    OcrolusDocumentType["A_1099_NEC"] = "A_1099_NEC";
    OcrolusDocumentType["A_1099_R"] = "A_1099_R";
    // Social security
    OcrolusDocumentType["SSA_1099"] = "SSA-1099";
    OcrolusDocumentType["SS_AWARD_LETTER"] = "SS_AWARD_LETTER";
    // Profit and loss
    OcrolusDocumentType["PROFIT_AND_LOSS"] = "PROFIT_AND_LOSS";
    // Pension
    OcrolusDocumentType["PENSION_AWARD_LETTER"] = "PENSION_AWARD_LETTER";
    // Veterans Affairs award letter,
    OcrolusDocumentType["VA_AWARD_LETTER"] = "VA_AWARD_LETTER";
    // Doc type to be ignored from handling
    OcrolusDocumentType["IGNORED_DOC"] = "IGNORED_DOC";
    // Not an official Ocrolus document type, we use it to indicate that Ocrolus wasn't able to read the document
    OcrolusDocumentType["UNKNOWN"] = "UNKNOWN";
})(OcrolusDocumentType || (exports.OcrolusDocumentType = OcrolusDocumentType = {}));
